import './Testimonials.css';

const TESTIMONIALS = [
  {
    initials: 'PG',
    name: 'Prakhar Agarwal',
    title: 'Hiring Manager · L4',
    quote: '"VERDICT gave us live visibility into every recruiter\'s pipeline. We went from weekly status meetings to real-time dashboards. Time-to-hire dropped by 40% in the first quarter."',
    metric: '40% faster hiring',
  },
  {
    initials: 'SA',
    name: 'Swati Agarwal',
    title: 'StoreAdmin · VERDICT User',
    quote: '"The assessment engine is exceptional. We created role-specific aptitude and technical tests in under an hour. Candidates get a fair, consistent evaluation every time — no bias."',
    metric: '883 tests created',
  },
  {
    initials: 'SG',
    name: 'Sobhit Gupta',
    title: 'Admin · VERDICT Platform',
    quote: '"The Candidate Portal changed how applicants experience our brand. They can see their status in real time, take assessments on their own time, and stay informed throughout. Dropout rate fell significantly."',
    metric: 'Dropout rate ↓',
  },
];

const COMPANIES = ['TechCorp India','FinServe Group','Aiprus Software','Retail Hub','LogiChain Co.','MedTech Pro'];

export default function Testimonials() {
  return (
    <section className="section-divider">
      <div className="section-wrap">
        <span className="eyebrow">Customer Stories</span>
        <h2 className="sec-title">Teams that hire with VERDICT.</h2>
        <p className="sec-sub" style={{ marginBottom: '3rem' }}>
          Hiring managers, recruiters, and HR leaders across industries rely on
          VERDICT to make better decisions — faster, fairer, and with full data.
        </p>

        <div className="testi-grid">
          {TESTIMONIALS.map(t => (
            <div key={t.name} className="testi-card">
              <div className="testi-card__metric">{t.metric}</div>
              <div className="testi-card__stars">★★★★★</div>
              <p className="testi-card__quote">{t.quote}</p>
              <div className="testi-card__author">
                <div className="testi-card__av">{t.initials}</div>
                <div>
                  <div className="testi-card__name">{t.name}</div>
                  <div className="testi-card__title">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trusted by strip */}
        <div className="trusted-strip">
          <p className="trusted-strip__label">Trusted by teams at</p>
          <div className="trusted-strip__logos">
            {COMPANIES.map(c => (
              <div key={c} className="trusted-logo">{c}</div>
            ))}
          </div>
        </div>

        {/* Animated floating metrics */}
        <div className="floating-metrics">
          {[
            { icon: '🏆', val: '49%',  label: 'Avg Pass Rate',     color: '#22c55e' },
            { icon: '📋', val: '883',  label: 'Tests Created',      color: '#8b5cf6' },
            { icon: '👥', val: '199',  label: 'Applicants Tracked', color: '#3b82f6' },
            { icon: '💼', val: '36',   label: 'Active Jobs',        color: '#f59e0b' },
            { icon: '⚡', val: '<2min',label: 'Avg Assignment',     color: '#a78bfa' },
            { icon: '🎯', val: '100%', label: 'Audit Trail',        color: '#14b8a6' },
          ].map((m, i) => (
            <div key={m.label} className="fm-card" style={{ '--fmc': m.color, animationDelay: `${i * 0.15}s` }}>
              <span className="fm-card__icon">{m.icon}</span>
              <div className="fm-card__val" style={{ color: m.color }}>{m.val}</div>
              <div className="fm-card__label">{m.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
